export default __webpack_public_path__ + "static/media/robby_contact.71c15314.png";